import { HostListener, ViewChild, Component, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HttpClient, HttpXhrBackend } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';
import * as Highcharts from 'highcharts';
import { ApiMethod } from '../../apimethods/api-method';
import { IndexModel, LogInfo } from './index-model';
declare var $;

const headers = {
  headers: { 'Access-Control-Allow-Origin': '*' }
};

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
/** index component*/
export class IndexComponent {
  modelItem: IndexModel = new IndexModel();
  aLoginID: string = localStorage.aLoginID;
  dataTable: any; dataTableRpt: any;
  dtOptions: any;
  tableData = [];
  @ViewChild('dataTable', { static: false }) table; @ViewChild('dataTableRpt', { static: false }) tableRpt;
  dataSet: any;

  TodayDueCt = ''; FilePendingCt = ''; FileDownloadCt = ''; FileUploadCt = '';

  constructor(private router: Router, private route: ActivatedRoute) {
    this.loadGeneralmethod();
  }

  loadGeneralmethod() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <IndexModel>data["VendorTracking"];
        this.getJournalsList();
        $("#lstJournals").select2({
          placeholder: "Select Journal", dropdownParent: "#divMainFilter"
        }); $("#lstJournals").val([]).trigger("change");

        $("#lstVolume").select2({
          placeholder: "Select Volume", dropdownParent: "#divMainFilter"
        });
        $("#lstVolume").val([]).trigger("change");

        $("#lstIssue").select2({
          placeholder: "Select Issue", dropdownParent: "#divMainFilter"
        });
        $("#lstIssue").val([]).trigger("change");

        customfunctions.SetDateValues('#Txt_FromDate', '#Txt_ToDate');

        this.GetDashboardDetails();

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  @HostListener('window:beforeunload') goToPage() {
    this.router.navigate(['/vendor-index']);
  }
  ngOnInit() {
    $('#ddlUploadStatus').select2({ dropdownParent: "#divMainFilter" });

    this.route.queryParamMap.subscribe(params => {
      if (params.get("type") != null) {
        let typeVal = GlobalConstants.GetTitleFormat(params.get("type"));
        $('#ddlUploadStatus').val(typeVal).change();
      }
    });

  }

  ngAfterViewChecked(): void {
    $('#divFailLog').css('max-height', GlobalConstants.size.height - 380);
    // check admin (1,5)
    if (localStorage.roleId != '1' && localStorage.roleId != '5') {
      $('.spPopup').removeAttr('onclick');
      $('.spPopup').removeAttr('style');
    }
  }

  resetFilter() {
    customfunctions.SetDateValues("#Txt_FromDate", "#Txt_ToDate");
    $("#lstJournals").val(0).change();
    $("#lstVolume").val(0).change();
    $("#lstIssue").val(0).change();
    this.GetInboxList('Inbox');
  }


  //Vendor Dashboard summary
  GetDashboardDetails(): void {
    $("#LoadingImage").show();
    var dashboardPostData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      FromDate: $('#Txt_FromDate').val(),
      ToDate: $('#Txt_ToDate').val(),


    };

    ApiMethod.postMethod(this.modelItem.DashboardApi, dashboardPostData).subscribe(
      resonse => {
        try {
          let asummaryList = resonse.aitemList;
          this.TodayDueCt = asummaryList[0]["TodayDue"];
          this.FilePendingCt = asummaryList[0]["FilePending"];
          this.FileDownloadCt = asummaryList[0]["FileDownload"];
          this.FileUploadCt = asummaryList[0]["FileUploaded"];

          let chartDataAllocate: any = []; let chartDataCom: any = []; let monthList: any = [];

          $(asummaryList).each(function (index, val) {
            chartDataAllocate.push({ y: val.AllocatedArticles, name: val.CurrentMonth });
            chartDataCom.push({ y: val.CompletedArticles, name: val.CurrentMonth });
            monthList.push(val.CurrentMonth);
          });

          this.LoadChartData(chartDataAllocate, chartDataCom, monthList);
          //Load Inbox list after Dashboard 
          //this.GetInboxList(false);
          $("#LoadingImage").hide();
        } catch (e) {
          ngswal("Warning !", e, "warning");
          $("#LoadingImage").hide();
        }
      },
      error => {
        console.log(error);
        $("#LoadingImage").hide();
      });

    var inboxPostData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      /*VendorID: localStorage.aLoginID,*/ //login vendor id
      FromDate: $('#Txt_FromDate').val(),
      ToDate: $('#Txt_ToDate').val(),
      UploadStatus: $('#ddlUploadStatus').val(),
      Journals: $("#lstJournals").val().toString(),
      Volume: $("#lstVolume option:selected").text(),
      Issue: $("#lstIssue option:selected").text(),

    };

    ApiMethod.postMethod(this.modelItem.InboxApi, inboxPostData).subscribe(
      resonse => {
        try {
          this.dataSet = JSON.stringify(resonse.aitemList); // Data List
          this.dataSet = JSON.parse(this.dataSet);
          this.dataTable = $(this.table.nativeElement);

          //Dynamic datable
          let acolList = resonse.acolListL;

          let dataItem = new DataParam();
          dataItem.acolList = acolList;
          dataItem.aNewButtonName = '';
          dataItem.dataTable = this.dataTable;
          dataItem.dataset = this.dataSet;
          dataItem.dtheight = (GlobalConstants.size.height - 330);
          dataItem.modulename = 'VendorInboxModule';
          dataItem.infoPopupID = 'AllocateID';
          //dataItem.rowSelect = true;
          dataItem.StateSave = true;

          this.dataTable = customfunctions.dynamicDataTable(dataItem);
          //Dynamic datable
          $("#LoadingImage").hide();
        }
        catch (e) {
          ngswal("Warning !", e, "warning");
          $("#LoadingImage").hide();
        }

      },
      error => {
        $("#LoadingImage").hide();
        console.log(error);
      }
    );
  }

  highchartsArea: typeof Highcharts = Highcharts; chartOptionsArea;

  LoadChartData(chartDataAllocate, chartDataComeleted, monthList): void {
    try {
      //Area Chart
      this.highchartsArea = Highcharts;
      this.chartOptionsArea = {
        chart: {
          type: 'area',
        },
        title: {
          text: 'Monthly Achievement'
        },
        xAxis: {
          categories: monthList,
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          }
        },
        tooltip: {
          headerFormat: '<span style = "font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
            '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: [
          {
            name: 'Allocated',
            data: chartDataAllocate,
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          },
          {
            name: 'Completed',
            data: chartDataComeleted,
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          }
        ],
      };
    } catch (e) {
      $("#LoadingImage").hide();
      ngswal(e);
    }
  }

  //Vendor Inbox List
  GetInboxList(tabType, IsLoadingImg = true): void {
    if (tabType === undefined)
      tabType = $("li.active").data('tabname');

    if (tabType == 'Dashboard')
      $('#divMainFilter').show();

    else
      $('#divMainFilter').hide();


    //if (tabType == 'Dashboard')
    //  $('#divMainFilter').hide();


    if (IsLoadingImg)
      $("#LoadingImage").show();

    var postData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      FromDate: $('#Txt_FromDate').val(),
      ToDate: $('#Txt_ToDate').val(),
      UploadStatus: $('#ddlUploadStatus').val(),
      Journals: $("#lstJournals").val().toString(),
      Volume: $("#lstVolume option:selected").text(),
      Issue: $("#lstIssue option:selected").text()
    };

    ApiMethod.postMethod(this.modelItem.InboxApi, postData).subscribe(
      resonse => {
        try {
          this.dataSet = JSON.stringify(resonse.aitemList); // Data List
          this.dataSet = JSON.parse(this.dataSet);
          this.dataTable = $(this.table.nativeElement);

          //Dynamic datable
          let acolList = resonse.acolListL;

          let dataItem = new DataParam();
          dataItem.acolList = acolList;
          dataItem.aNewButtonName = '';
          dataItem.dataTable = this.dataTable;
          dataItem.dataset = this.dataSet;
          dataItem.dtheight = (GlobalConstants.size.height - 330);
          dataItem.modulename = 'VendorInboxModule';
          dataItem.infoPopupID = 'AllocateID';
          //dataItem.rowSelect = true;
          dataItem.StateSave = true;

          this.dataTable = customfunctions.dynamicDataTable(dataItem);
          //Dynamic datable
          $("#LoadingImage").hide();
        }
        catch (e) {
          ngswal("Warning !", e, "warning");
          $("#LoadingImage").hide();
        }

      },
      error => {
        $("#LoadingImage").hide();
        console.log(error);
      }
    );
  }
  //Download Vendor package for process.
  Download() {
    let multiSelect = $('table.dataTable tbody tr.selected');
    if (multiSelect.length > 0) {
      let dataIdList = '';
      $.each(multiSelect, function (e, val) {
        dataIdList += $(this).find('i[class="fa fa-download"]').attr('data-col') + ',';
      });
      localStorage.aEID = dataIdList.replace(/,\s*$/, "");
      let apiurl = this.modelItem.MultiDownloadApi;
      ApiMethod.MultipleFileDownload(apiurl, localStorage.aEID);
    }
    else {
      let apiurl = this.modelItem.DownloadApi;
      ApiMethod.Downloadfile(apiurl + localStorage.aLoginID + '/' + localStorage.aPubID + '/' + localStorage.aEID + '/Download');
    }

  }

  DownloadErrorLog() {
    let apiurl = this.modelItem.DownloadApi;
    ApiMethod.Downloadfile(apiurl + localStorage.aLoginID + '/' + localStorage.aPubID + '/' + localStorage.aEID + '/ErrorLog');
  }
  PopupTitle;
  hide() {
    $('#divFileUpload').hide();
    let form: NgForm = $('form');
    form[0].reset();
  }

  VendorInfo(viewMethod) {
    if (localStorage.clicktype == 'spanpopup') {
      $("#LoadingImage").show();
      ApiMethod.getMethod(this.modelItem.VendorallocteApi + "/" + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImage").hide();
          let allocateItem = result.aitemList;
          localStorage.aEID = allocateItem.ArticleID;
          $('#btnPopupartMeta').trigger('click');
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "error");
        });
    }
    else {
      $("#LoadingImage").show();
      let idList = localStorage.aEID;
      let allocateSelect = $('table.dataTable tbody tr.selected');
      let allocateIdList = [];
      $.each(allocateSelect, function (e, val) {
        allocateIdList.push($($(val).find('td i')[0]).attr('data-col'));
      });
      if (allocateIdList.length > 0)
        idList = allocateIdList.toString();
      var postData = {
        IdList: idList
      };
      ApiMethod.postMethod(this.modelItem.VendorallocteListApi, postData).subscribe(
        result => {
          $("#LoadingImage").hide();
          let aitemL = result.aitemList; // Data List
          this.PopualteMultiple(viewMethod, aitemL);
          $("#LoadingImage").hide();
        },
        error => {
          $("#LoadingImagePopup").hide();
          ngswal("Warning !", error.message, "warning");
        }
      );
      return false;
    }
  }


  LogItem: LogInfo = new LogInfo();

  PopualteMultiple(viewMethod, aitemL): void {
    if (viewMethod == "Info") {
      this.PopupTitle = aitemL[0].PackageName;
      this.LogItem.AllocateDate = GlobalConstants.SetValue_FormatDate(aitemL[0].AllocateDate);
      this.LogItem.DueDate = GlobalConstants.SetValue_FormatDate(aitemL[0].DueDate);
      this.LogItem.DownloadDate = aitemL[0].DownloadDate;
      this.LogItem.UploadDate = aitemL[0].UploadDate;
      this.LogItem.UploadPackage = aitemL[0].UploadPackage;
      this.LogItem.UploadStatus = aitemL[0].UploadStatus;
      this.LogItem.ValidateStatus = aitemL[0].ValidateStatus;
      this.LogItem.FailureLogFile = aitemL[0].FailureLogFile;
      this.LogItem.Remarks = aitemL[0].ValidationRemakrs;
      $('#divLogInfo').show();
    }
    else {
      let cssStyle = 'style="border: solid 1px;padding:10px"';
      let packageList = '<table width="100%" ' + cssStyle + '><thead ' + cssStyle + '>'
        + '<th ' + cssStyle + '>Article ID</th><th ' + cssStyle + '>Package Name </th></thead>';
      let waringInfo = this.modelItem.PartialUploadMsg;
      let uploadCt = 0;
      $.each(aitemL, function (e, val) {
        if ((val.UploadStatus == "Uploaded" || val.UploadStatus == "Completed") && val.ValidateStatus != "Failed") {
          uploadCt++;
        }
        packageList += '<tr data-artno="' + val.PackageName + '">';
        packageList += '<td ' + cssStyle + '>' + val.ArticleNo + '</td>';
        packageList += '<td ' + cssStyle + '>' + val.PackageName + '</td>';
        packageList += '</tr>';
      });
      packageList += '</table>';
      if (uploadCt > 0) {
        ngswal("warning !", waringInfo, "warning");
      }
      else {
        $('#lblPkgList').html(packageList);
        $('#divFileUpload').show();
        localStorage.UploadApi = this.modelItem.UploadApi;

        $('.upload').html('');
      }
    }
  }


  public progress: number;
  public message: string;
  @Output() public onUploadFinished = new EventEmitter();
  public uploadFile = (files) => {
    let formData = new FormData();
    let apiurl = this.modelItem.UploadApi;
    let selectedRow = $('#lblPkgList table tbody tr');
    if (files.length === 0) {
      return false;
    }
    if (selectedRow.length != files.length) {
      ngswal("Warning !", "Selected articles and Upload packages count mismatched !", "warning");
      $('input[type="file"]').val('');
      return false;
    }
    let fileToUpload = <File>files;
    let invalidPkg = '';

    $.each(fileToUpload, function (e, val) {
      let chkPkg = $('#lblPkgList table tbody tr[data-artno="' + val.name.trim() + '"]');
      if (chkPkg.length == 0) {
        invalidPkg += val.name + ',';
      }
      formData.append('file', val, val.name.trim());
    });
    if (invalidPkg != '') {
      ngswal({
        title: "Package name not matched! ",
        text: invalidPkg,
        type: "warning",
      });
      $('input[type="file"]').val('');
      return false;
    }
    ngswal({
      title: "Confirmation !",
      text: "Are you sure you want to upload the package?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          formData.append('ClientApiUrl', apiurl);
          formData.append('Id', localStorage.aEID);
          formData.append('LoginId', localStorage.aLoginID);
          formData.append('PublisherId', localStorage.aPubID);
          $("#LoadingImagePopup").show();

          ngswal({
            title: "Processing package upload",
            text: 'Please wait to upload response !.....',
            showCancelButton: false,
            showConfirmButton: false
          });

          let http = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));
          http.post($('base')[0].href + 'api/Endpoint/PostFileListClient', formData).subscribe(
            (response: Response) => {
              let msgInfo = 'Success'; let msgDetails = '';
              let result = $(response.headers);
              $.each(result, function (e, val) {
                if (val.key == 'ErrorMessage') {
                  msgInfo = 'Warning';
                  msgDetails = val.value.toString();
                }
                else if (val.key == 'SuccessMessage') {
                  msgInfo = 'Success';
                  msgDetails = val.value.toString();
                }
              });
              ngswal({
                title: "<i>" + msgInfo + "</i>",
                type: msgInfo.toLowerCase(),
                text: msgDetails,
                html: true
              });

              $('#btnHideTrigger').trigger('click');
              $('#btnLoadList').trigger('click');
              $("#LoadingImagePopup").hide();
            },
            (error) => {
              console.log(error.message);    // Show error, if any.
              ngswal("Warning !", error.message, "warning");
              $("#LoadingImagePopup").hide();
            }
          );

        } else {
          ngswal("Cancelled", "Your Click cancel! :)", "warning");
        }
      }
    );
    return true;
  }

  journalList: any;
  issueList: any;
  volumeList: any;


  getJournalsList() {
    //const publisherId = 1;//$('#lstPublisher').val();
    ApiMethod.getMethod(this.modelItem.GetJournalList + "/" + localStorage.aPubID + "/" + localStorage.aLoginID).subscribe(
      result => {
        this.journalList = result.aitemJournalList;
      }, error => {
        $("#LoadingImage").hide();
        console.log(error.message);
      });
  }

  getVolumeIssue() {
    var journals = $("#lstJournals").val().toString();

    ApiMethod.getMethod(this.modelItem.VolumeIssueListAPI + "/" + journals).subscribe(
      result => {
        this.volumeList = result.volumeList;
        this.issueList = result.issueList;

        $("#lstIssue").val(-1).trigger("change");
        $("#lstVolume").val(-1).trigger("change");

      }, error => {
        $("#LoadingImage").hide();
        console.log(error.message);
      });
  }
}
